<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline" v-if="detect == 'pc'">
                <h2 class="tit">나누리상품권 구매내역</h2>
            </div>

            <v-divider class="d-md-none" />

            <v-card elevation="0" style="overflow:visible">
                <v-card-text :class="{ 'pa-0': detect == 'pc' }">
                    <div class="mb-4">
                        <nshop-order-list-filter />
                    </div>

                    <nshop-order-list-state class="mb-2 mb-md-12" />

                    <div>
                        <v-data-table
                            v-bind="{
                                items,
                                headers,
                                itemsPerPage: -1,
                            }"
                            hide-default-footer
                            disable-pagination
                            disable-sort
                            class="nshop-order-table"
                        >
                            <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
                            <template #[`item.pins`]="{ value, item, header }">
                                <nshop-order-item-pins v-bind="{ value: item }" v-slot="{ attrs, on }">
                                    <v-card color="transparent" elevation="0" v-bind="attrs" v-on="on">
                                        {{ header.formatter.bind(item)(value, item) }}
                                    </v-card>
                                </nshop-order-item-pins>
                            </template>
                            <template #[`item.state`]="{ value, item, header }">
                                <nshop-order-item-state v-bind="{ value: item }" @input="updateItem" v-slot="{ attrs, on }">
                                    <v-card color="transparent" elevation="0" v-bind="attrs" v-on="on">
                                        {{ header.formatter.bind(item)(value, item) }}
                                    </v-card>
                                </nshop-order-item-state>
                            </template>
                        </v-data-table>
                    </div>

                    <div class="mt-30px mt-md-40px">
                        <v-pagination
                            v-bind="{
                                value: page,
                                length: pageCount,
                                'total-visible': 11,
                            }"
                            @input="(page) => $router.push({ query: { ...$route.query, page } })"
                        />
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <common-loader v-bind="{ loading }" />
    </component>
</template>
<script>
import api from "@/api";
import detect from "@/plugins/detect";
import { initDataTableHeaders } from "@/assets/lib";
import { initNshopOrder, List_NshopOrder_State, NSHOP_ORDER_STATES } from "@/store/nshop";

import CommonLoader from "@/components/common/common-loader.vue";
import NshopOrderItemPins from "@/components/client/mypage/nshop/nshop-order-item-pins.vue";
import NshopOrderItemState from "@/components/client/mypage/nshop/nshop-order-item-state.vue";
import NshopOrderListFilter from "@/components/client/mypage/nshop/nshop-order-list-filter.vue";
import NshopOrderListState from "@/components/client/mypage/nshop/nshop-order-list-state.vue";

export default {
    components: {
        CommonLoader,
        NshopOrderItemPins,
        NshopOrderItemState,
        NshopOrderListFilter,
        NshopOrderListState,
    },
    data: () => ({
        /** @type {import('@/store/nshop').NshopOrder[]} */
        orders: [],
        summary: { totalCount: 0 },

        limit: 10,
        detect,

        loading: false,
    }),
    computed: {
        template() {
            switch (detect) {
                case "pc": {
                    return () => import(`@/templates/${this.$theme.pages.mypage}`);
                }

                case "mobile": {
                    return () => import(`@/templates/${this.$theme.pages.default}`);
                }
            }
        },
        headers() {
            return initDataTableHeaders([
                {
                    text: "No",
                    value: "index",
                    align: "end",
                    width: +60,
                    formatterType: "number",
                },
                {
                    text: "주문일시",
                    value: "createdAt",
                    align: "center",
                    width: 110,
                    formatterType: "datetime",
                },
                {
                    text: "주문번호",
                    value: "orderNo",
                    align: "center",
                    width: 120,
                },
                {
                    text: "권종",
                    value: "orderName",
                    align: "center",
                    width: 120,
                },
                {
                    text: "수량",
                    value: "count",
                    align: "center",
                    width: +70,
                    formatterType: "number",
                    formatterSuffix: "개",
                },
                {
                    text: "상품권 번호",
                    value: "pins",
                    align: "center",
                    formatter: (pins) => {
                        let text = pins?.[0]?.pno;
                        if (!text) return "-";
                        if (1 < pins.length) text += ` 외 ${(pins.length - 1).format()}건`;
                        return text;
                    },
                },
                {
                    text: "결제금액",
                    value: "price.sale",
                    align: "center",
                    width: 110,
                    formatterType: "number",
                    formatterSuffix: "원",
                },
                {
                    text: "상태",
                    value: "state",
                    align: "center",
                    width: +90,
                    formatter: (value) => NSHOP_ORDER_STATES[value]?.text || "-",
                },
            ]);
        },
        items() {
            return [...this.orders].map((item, index) => initNshopOrder({ ...item, index: this.summary.totalCount - this.skip - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { state, ...query } = this.$route.query;

            delete query.page;

            query.state = List_NshopOrder_State.find((item) => item.value === state)?.param;
            if (query.state) query.state = JSON.stringify(query.state);
            else delete query.state;

            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, orders } = await api.v1.me.nshop.orders.gets({
                    headers: { skip, limit },
                    params,
                });

                this.orders = orders;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },

        updateItem(item) {
            const index = this.orders.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.orders.splice(index, 1, item);
            else {
                this.orders = [item, ...this.orders];
                this.summary.totalCount += 1;
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
.nshop-order-table {
    &,
    ::v-deep *,
    ::v-deep td {
        font-size: 14px !important;
        line-height: 1.25 !important;
    }
}
</style>
